import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import english from './locales/en/english.json';

// lazy loaders for other locales to avoid bundling them into the main chunk
const localeLoaders = {
  bn: () => import('./locales/bn/bangla.json'),
  ita: () => import('./locales/ita/italian.json'),
  hin: () => import('./locales/hin/hindi.json'),
  ara: () => import('./locales/ara/arabic.json'),
};

export async function loadLanguage(lang) {
  const loader = localeLoaders[lang];
  if (!loader) return Promise.resolve();
  if (!i18n.hasResourceBundle(lang, 'translation')) {
    const mod = await loader();
    const data = mod?.default || mod;
    i18n.addResourceBundle(lang, 'translation', data, true, true);
  }
  return i18n.changeLanguage(lang);
}

// the translations (keep default language statically)
const resources = {
  en: {
    translation: english
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources, // resources are important to load translations for the languages.
    lng: "en", // default language
    debug: false,
    fallbackLng: "bn",
    interpolation: {
      escapeValue: false
    },
    ns: "translation",
    defaultNS: "translation"
  });

export default i18n;